<template lang="html">
    <div>
        <div class="select-countries__wrapper" 
            @click="notifyCannotChangeCountry()">
            <UiInput
                label="Țară"
                image="globe.svg"
                :placeholder="countrySearchOpen ? 'Căutați o țară' : 'ex. Romania'"
                :value="countrySearchOpen ? countrySearch :country"
                :disabled="isLoading || isSettingsPage"
                :error="errors.country"
                @input="searchCountry"
                @blur="closeSearch"
                @focus="countrySearchOpen = true, validateCountry()"
                @keyup="submit"
            />
            
            <div class="select-countries" v-if="countrySearchOpen">
                <p v-if="countries === null" style="padding: 0 15px;">
                    Se incarca...
                </p>
                <div v-else-if="countrySearch === ''">
                    <div
                        class="select-countries__item"
                        v-for="countryItem of countries"
                        @click="country = countryItem.name"
                    >
                        <img :src="countryItem.flag_url" />
                        {{ countryItem.name }}
                    </div>
                </div>
                <p v-else-if="countrySearch.trim().length < 2" style="padding: 0 15px;">
                    Introduceți măcar două caractere
                </p>
                <div v-else>
                    <div v-for="countryItem of filteredCountries"
                        :key="countryItem.name"
                        class="select-countries__item"
                        @click="country = countryItem.name">

                        <img :src="countryItem.flag_url" />
                        {{ countryItem.name }}
                    </div>
                </div>
            </div>
        </div>

        <UiInput
            label="Județ"
            image="diagram.svg"
            placeholder="ex. Iași"
            @input="county = $event;"
            :value="county"
            :disabled="isLoading"
            @keyup="submit"
        />

        <UiInput
            label="Oraș"
            image="city.svg"
            placeholder="ex. Iași"
            :value="city"
            :disabled="isLoading"
            :error="errors.city"
            @input="city = $event; validateCity()"
            @blur="validateCity"
            @keyup="submit"
        />

        <UiInput
            label="Adresă de facturare"
            image="map-marker.svg"
            placeholder="ex. Strada Mircea nr. 21 bloc L1 scara A"
            :value="address"
            :disabled="isLoading"
            :error="errors.address"
            @input="address = $event; validateAddress()"
            @blur="validateAddress"
            @keyup="submit"
        />

        <UiCheckbox
            :id="1"
            :checked="isCompany"
            label="Persoană juridică"
            @input="isCompany = $event"
        />

        <br />

        <template v-if="isCompany">
            <UiInput
                label="Nume firma"
                image="building.svg"
                placeholder="ex. Macarale SRL"
                :value="companyName"
                :disabled="isLoading"
                :error="errors.companyName"
                @input="companyName = $event; validateCompanyName()"
                @blur="validateCompanyName"
                @keyup="submit"
            />

            <UiInput
                label="CUI"
                image="fingerprint.svg"
                placeholder="ex. 1234567"
                :value="cui"
                :disabled="isLoading"
                :error="errors.cui"
                @input="cui = $event; validateCUI()"
                @blur="validateCUI"
                @keyup="submit"
            />
        </template>

        <div style="margin: 20px;">
            <p class="error">{{ apiError }}</p>
            
            <small style="display: block; margin-bottom: 15px;">
                * Aceste informații sunt necesare pentru a emite factura fiscală în cazul unei eventuale achiziții.
            </small>
            
            <UiButton style="min-width: 100%;"
                @click="submit({ keyCode: 13 })" 
                :disabled="disabledButton" 
                :name="oneMoreStep ? 'Continuă' : 'Actualizează'"
                class="form-group-button" />
        </div>
    </div>
</template>

<script>
import UiButton from '@/components/ui/Button'
import UiCheckbox from '@/components/ui/Checkbox'
import UiInput from '@/components/ui/Input'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

import axios from 'axios'
import config from '@/config.js'
    
export default {
    components: {
        UiButton,
        UiCheckbox,
        UiInput
    },
    data() {
        return {
            country: '',
            countrySearch: '',
            countrySearchOpen: false,
            county: '',
            city: '',
            address: '',
            isCompany: false,
            companyName: '',
            cui: '',
            filteredCountries: [],
            errors: {
                country: '',
                city: '',
                address: '',
                isCompany: '',
                companyName: '',
                cui: '',
            },
            apiError: null,
            isLoading: false,
        };
    },
    async mounted() {
        if (this.oneMoreStep === false) {
            this.country = this.user.address.country || '';
            this.county = this.user.address.county || '';
            this.city = this.user.address.city || '';
            this.address = this.user.address.address || this.user.address.adress || '';
            this.isCompany = this.user.address.individual === 0;
            this.companyName = this.user.address.company_name || '';
            this.cui = this.user.address.cui || this.user.address.identification_number || '';
        }
        
        if(!this.country)
        await this.fetchCountries({
            defaultCountry: true
        });

        if(this.defaultCountry) this.country = this.defaultCountry;
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            countries: 'settings/countries',
            firstStep: 'settings/firstStep',
            defaultCountry: 'settings/defaultCountry',
        }),
        oneMoreStep() {
            return (this.user && !this.user.address);
        },
        disabledButton() {
            if (this.isLoading) return true;
            if (
                this.errors.country === ''
                && this.errors.city === ''
                && this.errors.address === ''
                && (
                    this.country.length > 0
                    && this.city.length > 0
                    && this.address.length > 0
                )
                && (
                    this.isCompany === false
                    || (
                        this.errors.companyName === ''
                        && this.errors.cui === ''
                        && (
                            this.companyName.length > 0
                            && this.cui.length > 0
                        )
                    )
                )
            ) {
                return false;
            }

            return true;
        },
        isSettingsPage() {
            return this.$route.path === `/client/settings`;
        }
    },
    methods: {
        ...mapActions({
            fetchUser: 'user/user',
            fetchCountries: 'settings/fetchCountries',
            updateBillingInfo: 'settings/updateBillingInfo',
        }),
        searchCountry(event) {
            this.countrySearch = event;
            this.filteredCountries = [];

            if (this.countrySearch.trim().length > 1) {
                const q = this.countrySearch.toLowerCase();
                for (const country of this.countries) {
                    if (country.name.toLowerCase().includes(q)) {
                        this.filteredCountries.push(country);
                    }
                }
            }
        },
        validateCountry() {
            this.apiError = null;
            this.errors.country = '';

            if (this.country === '') {
                this.errors.country = 'Selecteaza o tară';
                return;
            }
        },
        validateCity() {
            this.apiError = null;
            this.errors.city = '';

            if(this.city.length < 3 || this.city.length > 60)
                this.errors.city = 'Orașul trebuie să conțină minim 3 și maxim 60 de caractere';
        },
        validateAddress() {
            this.apiError = null;
            this.errors.address = '';

            if(this.address.length < 6 || this.address.length > 220)
                this.errors.address = 'Adresa trebuie să conțină minim 6 si maxim 220 de caractere';
        },
        validateCompanyName() {
            this.apiError = null;
            this.errors.companyName = '';

            if (this.companyName.length < 3 || this.companyName.length > 60)
                this.errors.companyName = 'Numele trebuie sa conțină minim 3 si maxim 60 de caractere';
        },
        validateCUI() {
            this.apiError = null;
            this.errors.cui = '';

            const cui = this.cui;
            var cif = cui;

            if(isNaN(parseFloat(cui)) || !isFinite(cui)){
                cif = cif.toUpperCase();
                if(cif.indexOf('RO') === 0){
                    cif = cif.replace('RO', '');
                } else {
                    this.errors.cui = 'Codul CUI este invalid';
                    return;
                }

                cif = parseInt(cif.trim());
            } else {
                cif = parseInt(cif);
            }

            if(cif.toString().length > 10 || cif.toString().length < 6){
                this.errors.cui = 'Codul CUI este invalid';
                return;
            }

            var v = 753217532;

            var c1 = parseInt(cif % 10);
            cif = parseInt(cif / 10);

            var t = 0;
            while (cif > 0) {
                t += (cif % 10) * (v % 10);
                cif = parseInt(cif / 10);
                v = parseInt(v / 10);
            }

            var c2 = parseInt((t * 10) % 11);

            if(c2 == 10){
                c2 = 0;
            }

            if (c1 !== c2) {
                this.errors.cui = 'Codul CUI este invalid';
            }
        },

        closeSearch() {
            setTimeout(() => {
                this.countrySearchOpen = false;
                this.validateCountry();
            }, 100);
        },

        async submit(event) {
            if (event.keyCode !== 13) {
                return;
            }

            if(this.disabledButton || this.isLoading) {
                return;
            }

            this.errors.country = '';
            this.errors.city = '';
            this.errors.address = '';
            this.errors.isCompany = '';
            this.errors.companyName = '';
            this.errors.cui = '';

            this.isLoading = true;

            const query = {
                country: this.country,
                county: this.county,
                city: this.city,
                address: this.address,
                is_company: this.isCompany,
            };

            if (this.isCompany) {
                query.company_name = this.companyName;
                query.identification_number = this.cui;
                query.cui = this.cui;
            }

            await this.updateBillingInfo(query);
            this.isLoading = false;
        },
        notifyCannotChangeCountry() {
            if(this.isSettingsPage) {
                this.$store.state.notification.notification.icon = null;
                this.$store.state.notification.notification.title = null;
                
                setTimeout(() => {
                    this.$store.state.notification.notification.icon = 'warning';
                    this.$store.state.notification.notification.title = 'Țara nu mai poate fi modificată! Contactați-ne în live chat pentru mai multe detalii.';
                }, 200);
            }
        }
    },
    watch: {
        "user"(newVal) {
            if (this.oneMoreStep === false) {
                this.country = this.user.address.country || '';
                this.county = this.user.address.county || '';
                this.city = this.user.address.city || '';
                this.address = this.user.address.address || this.user.address.adress || '';
                this.isCompany = this.user.address.individual === 0;
                this.companyName = this.user.address.company_name || '';
                this.cui = this.user.address.cui || this.user.address.identification_number || '';
            }
        },
        "defaultCountry"(newVal) {
            // Exclude console error for localhost
            this.country = !newVal ? '' : newVal;
        }
    }
}
</script>

<style lang="scss" scoped>
    // @import "@/scss/pages/billing-info";

    .form-group {
        margin: 0 auto;
        margin-top: 30px;
        text-align: left;
        max-width: 600px;
        position: relative;
    }

    .error {
        color: var(--error-color);
    }

    .select-countries__wrapper {
        position: relative;
    }

    .select-countries {
        background: #ffffff;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
        // border-radius: 10px;
        border: 1px solid $color-secondary;
        left: 0;
        max-height: 300px;
        overflow: auto;
        position: absolute;
        top: calc(100% + 5px);
        z-index: 30;
        width: 100%;
    }

    .select-countries__item {
        align-items: center;
        display: flex;
        cursor: pointer;
        padding: 5px 10px;
    }

    .select-countries__item:hover {
        background: #eee;
    }

    .select-countries__item > img {
        margin-right: 7px;
        width: 30px;
    }
</style>
